import {applyMiddleware, compose, createStore} from 'redux';
import {createEpicMiddleware} from 'redux-observable';
import {createBrowserHistory} from 'history';
import {routerMiddleware} from 'connected-react-router';
import rootReducer from 'ducks';
import rootEpics from 'epics';

export const history = createBrowserHistory();
const epic = createEpicMiddleware();

const createMiddleware = () => {
  const router = routerMiddleware(history);
  const middlewares = [router, epic];
  if (process.env.NODE_ENV === 'development') {
    const logger = require('middlewares/logger').default;
    return applyMiddleware(logger, ...middlewares);
  }
  return applyMiddleware(...middlewares);
};

export default (initialState = {}) => {
  const middlewares = createMiddleware();
  const store = createStore(
    rootReducer(history),
    initialState,
    compose(middlewares),
  );
  epic.run(rootEpics);
  return store;
};
